import React, { useState } from 'react';

const Skills3D = ({ data }) => {
  const { skills } = data;
  const [activeCategory, setActiveCategory] = useState('all');

  // Filter skills based on active category
  const filteredSkills = activeCategory === 'all'
    ? skills?.technical
    : skills?.technical?.filter(skill => skill.category === activeCategory);

  return (
    <section id="skills" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-16 h-0.5 bg-gradient-to-r from-transparent to-blue-500"></div>
            <span className="text-blue-400">Technical Expertise</span>
            <div className="w-16 h-0.5 bg-gradient-to-l from-transparent to-blue-500"></div>
          </div>
          <h2 className="section-title">Skills & Technologies</h2>
          <p className="section-subtitle">
            A comprehensive toolkit for building modern web applications
          </p>
        </div>

        {/* Category Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12 max-w-5xl mx-auto">
          {skills?.categories?.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${activeCategory === category.id
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30'
                  : 'bg-white/5 text-gray-400 border border-white/10 hover:bg-white/10 hover:text-white'
                }`}
            >
              <i className={`fas ${category.icon}`}></i>
              {category.label}
            </button>
          ))}
        </div>

        {/* Skills Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4 max-w-7xl mx-auto">
          {filteredSkills?.map((skill, index) => (
            <div
              key={`${activeCategory}-${index}`}
              className="skill-flip animate-fade-in-up"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="skill-flip-inner">
                {/* Front */}
                <div className="skill-flip-front">
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center text-xl mb-2"
                    style={{ backgroundColor: `${skill.color}1a`, color: skill.color }}
                  >
                    <i className={skill.icon}></i>
                  </div>
                  <h3 className="text-base font-bold text-slate-800">{skill.name}</h3>
                </div>
                {/* Back */}
                <div
                  className="skill-flip-back"
                  style={{ background: `linear-gradient(135deg, ${skill.color}, ${skill.color}cc)` }}
                >
                  <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center text-white text-xl mb-2">
                    <i className={skill.icon}></i>
                  </div>
                  <h3 className="text-base font-bold text-white">{skill.name}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills3D;
